import React, { useState } from 'react';
import './ForgetPassword.scss'
import { useTranslation } from 'react-i18next';
import HeaderSimple from './../../components/HeaderSimple/HeaderSimple'
import Footer from './../../components/Footer/Footer'
import { useNavigate } from 'react-router-dom';
import api from "../../../services/api"; 


function ForgetPassword() {
    const { t } = useTranslation();
    const language = localStorage.getItem('language');
    const navigate = useNavigate();
    const [errors, setErrors] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [user, setUser] = useState({
        email: '',
    });

    const handleSubmit = async (e) => {
      e.preventDefault();
      setErrors({}); 
      try {
          await api.post("/user/reset-password", user, {
            headers: { "Content-Type": "application/json" },
          });
          navigate("/");
        } catch (errors) {
          if (errors.response?.data?.errors) {
            setErrors(errors.response.data.errors);
          } else {
            setErrors(t("login-error"));
          }
        } 
        // axios.post('/user/reset-password', user, {  
        //     headers: {
        //     'Language': language,
        //     'Content-Type': 'application/json',
        //     },
        // })
        // .then(response => {
        //     navigate("/")
        // })
        // .catch(error => {
        //     console.error('Erro:', error);
        //     if (error.response && error.response.data) {
        //         const serverErrors = error.response.data;
        //         const formattedErrors = Object.fromEntries(
        //             Object.entries(serverErrors).map(([key, value]) => [key, value[0]])
        //         );
        //         setErrorss(formattedErrors); 
        //     } else {
        //         setErrors({ general: 'Erro ao enviar os dados. Por favor, tente novamente.' });
        //     }
        // });
  };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUser((prev) => ({
          ...prev,
          [name]: value,
        }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    };

    return (
        <>
          <HeaderSimple />
          <section className='forgetPassword'>
              <div className='container'>
                  <h2>{t('forget-password-title')}</h2>
                  <form onSubmit={handleSubmit}>
                      <input name="email"
                      value={user.email}
                      placeholder={t('forget-password-text')}
                      onChange={handleInputChange} />
                      {errors?.email && <p className="error">{errors.email}</p>}
                      <button type="submit">{t('forget-password-button')}</button>
                  </form>
              </div>
          </section>
          <Footer/>
        </>
    );
}

export default ForgetPassword;